import React, { useRef, useState } from "react";
import { LogoutOutlined, MessageOutlined } from "@ant-design/icons";
import userimg from "../../static/images/user.png";
import { useDrawer } from "../layout-components/menu/menuContext";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "../../Config/AppConfig";
import { BackIcon } from "./icons";
import AiAdvisorLogo from "../../static/images/AiAdvisorlogo.png";
import CustomModal from "./CustomModal";
import { formatCSVData } from "../../utils/utils";
import axiosInstance from "../../service/AxiosInstance";
import { Tooltip, Button } from "antd";
import axios from "axios";
import { PortfolioNotification } from "./PortfolioNotification";
import WhiteLogo from "../../static/images/Jump_White.png";
import ReportFeedbackModal from "../aiAnalytics/ReportFeedbackModal";
import ReleaseNotesModal from "../landingPage/ReleaseNotesModal";
// import logo from "../../static/images/JUMPV_logo.png";

function Nav({ routeKey }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isPortfolioRoute = routeKey.includes("portfolio");
  const isPortfolioDirectoryRoute = routeKey.toLowerCase().includes("directory");
  const isValuationEdit = routeKey.toLowerCase().includes("valuationedit");
  const isValuationEdit2 = location.pathname.includes(
    "/Valuations/ValuationEdit/debug=true"
  );
  // Check if we're on valuation directory page, but NOT on valuation edit page
  const isValuationDirectory = (location.pathname.includes("/JumpFive/valuations") || location.pathname.includes("/JumpFive/Valuations")) 
    && !location.pathname.includes("/ValuationEdit/") 
    && !isValuationEdit;
  
  const isPortfolioDirectory = location.pathname.includes("/JumpFive/Portfolio/PortfolioDirectory");
  const isPortfolioBuilder = location.pathname.includes("/JumpFive/Portfolio/PortfolioBuilder");
  const isPortfolioBuilderSearch = location.pathname.includes(
    "/PortfolioBuilder/PortfolioList/debug=true"
  );
  const isPortfolioEditDebug = location.pathname.includes(
    "/Portfolio/PortfolioEdit/debug=true"
  );
  const isPortfolioEdit = location.pathname.includes("/JumpFive/Portfolio/PortfolioEdit");
  const portfolioEdit = routeKey.toLowerCase().includes("portfolioedit");
  
  // Check if we're on the report results page
  const isReportResultsPage = location.pathname.includes("/ai-analytics/report-results");
  
  // Check if we're on the AI Analytics main page
  const isAIAnalyticsPage = location.pathname.includes("/ai-analytics");
  
  // Check if we're on the Market Share page
  const isMarketSharePage = location.pathname.includes("/ai-analytics/market-share");
  
  const username = sessionStorage.getItem("user_name");
  const { state, dispatch } = useDrawer();
  const {
    valuationName,
    portfolioName,
    portfolioData,
    portfolioCols,
    dataLoading,
    singleDealer,
  } = state;
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("0");
  const [tabResults, setTabResults] = useState({});
  const abortControllerRef = useRef(null); // Ref for AbortController
  
  // Release notes modal state
  const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = useState(false);
  const [releaseNotesContent, setReleaseNotesContent] = useState(null);

  const tabPromptTypes = {
    0: "prompt2",
    1: "prompt1",
    2: "prompt3",
  }; // Map tab keys to prompt types

  const sendCSVDataWithParams = async (data, extraParams, requestId) => {
    if (!data || data.length === 0) {
      setResponse("Data not available");
      setLoading(false);
      return;
    }
    const controller = new AbortController();
    abortControllerRef.current = controller; // Store controller in ref
    setLoading(true);

    try {
      // Send FormData via POST request
      const config = {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
        },
        signal: controller.signal,
      };
      if (state.currentStep === 1 && isValuationEdit2) {
        const dealerResponse = await axiosInstance.post(
          "single_dealer_openai_response",
          { debug_param: "true", dealer_json: singleDealer },
          { signal: controller.signal }
        );
        setResponse(dealerResponse.data);
        setTabResults({ 0: dealerResponse.data }); // Save response for the first tab
        return;
      } else {
        //  Generate the CSV content
        const headers = Object.keys(data[0]).join(",");
        const rows = data.map((row) =>
          Object.values(row)
            .map((value) => `"${value}"`) // Quote values to handle commas
            .join(",")
        );
        const csvContent = [headers, ...rows].join("\n");

        // Create a Blob for the CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });

        // Construct the file name dynamically
        const fileName = `${portfolioName}.csv`;

        // Create FormData to send the file with the correct name
        const formData = new FormData();
        formData.append("files", blob, fileName); // Append the file content with the filename
        Object.keys(extraParams).forEach((key) => {
          formData.append(key, extraParams[key]);
        });

        formData.append("debug_param", "true");

        const response = await axiosInstance.post(
          "basic_openai_response",
          formData,
          config
        );

        setResponse(response.data);
      }

      // Validate if this response belongs to the current active request
      // Ensure response is only set for active requests
      if (controller.signal.aborted) {
        console.log("Request aborted, skipping response handling");
        return;
      }
    } catch (error) {
      console.log(error.name, "error");
      if (axios.isCancel(error)) {
        console.log("Request was canceled:", error.message);
      } else {
        console.error("Error uploading file:", error);
      }
    } finally {
      setLoading(false);
    }
  };
  const formattedData =
    portfolioData && portfolioCols
      ? formatCSVData(portfolioData, portfolioCols)
      : null; // Default to null or an empty array if dependencies are unavailable

  const handleTabDataFetch = (tabKey) => {
    // Clear the response to prevent stale data
    setResponse(null);
    setLoading(true);

    if (tabResults[tabKey]) {
      // If data for this tab already exists, use it
      setResponse(tabResults[tabKey]);
      setLoading(false);
      return;
    }
    if (tabResults[tabKey]) {
      // If data for this tab already exists, skip API call
      return;
    }

    const promptType = tabPromptTypes[tabKey];
    const extraParams = { prompt_type: promptType };

    if (portfolioData && portfolioCols) {
      // if (tabKey === "0") {
      //   // Skip API call for the fourth tab
      //   setLoading(false);
      //   setResponse("Data not available for this tab.");
      //   return;
      // }
      sendCSVDataWithParams(formattedData, extraParams, tabKey);
    } else if (singleDealer) {
      sendCSVDataWithParams(singleDealer, { debug_param: "true" }, tabKey);
    } else {
      setLoading(false);
      setResponse("No data available");
    }
  };
  const handleMenuClick = () => {
    dispatch({ type: "OPEN_DRAWER" });
  };

  const handleLogout = () => {
    sessionStorage.clear();
    
    // Clear pending AI Analytics reports from global state
    dispatch({
      type: "CLEAR_PENDING_REPORTS"
    });
    
    // window.location.reload();
    // event.preventDefault();
    navigate(`${AUTH_PREFIX_PATH}/login`);
  };

  const handleLogoClick = () => {
    const saveForm = {
      status: false,
      step: 0,
      prevStep: 0,
    };

    dispatch({ type: "SET_STEP", value: 0 });

    dispatch({ type: "UPDATE_PAYLOAD_DB", value: saveForm });
    // window.location = "/JumpFive/Valuations/";
    // history("/JumpFive/home");
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleImageClick = () => {
    // Clear stale data when opening the modal
    setResponse(null);
    setLoading(false);
    setActiveTab("0"); // Reset to the first tab
    setTabResults({}); // Clear previous tab results
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null; // Reset ref
    }
  };
  const isAiAdvisorDisabled = dataLoading;

  const handleFeedbackClick = () => {
    // Dispatch custom event to open feedback modal for all cases
    window.dispatchEvent(new CustomEvent('openFeedbackModal'));
  };

  const handleBetaVersionClick = async () => {
    try {
      // Get release notes content from sessionStorage
      const storedContent = sessionStorage.getItem('release_notes_content');
      if (storedContent) {
        const content = JSON.parse(storedContent);
        setReleaseNotesContent(content);
        setIsReleaseNotesModalOpen(true);
      } else {
        console.log("No release notes content found in sessionStorage, fetching...");
        // Fetch the data if not available
        try {
          const response = await axiosInstance.get('/fetch_release_notes');
          if (response.data) {
            sessionStorage.setItem('release_notes_content', JSON.stringify(response.data));
            setReleaseNotesContent(response.data);
            setIsReleaseNotesModalOpen(true);
          }
        } catch (fetchError) {
          console.error("Error fetching release notes:", fetchError);
        }
      }
    } catch (error) {
      console.error("Error opening release notes modal:", error);
    }
  };

  const handleReleaseNotesClose = () => {
    setIsReleaseNotesModalOpen(false);
    setReleaseNotesContent(null);
  };

  return (
    <>
    <PortfolioNotification/>
    <header
      data-advancedhtml=""
      role="banner"
      className="header"
      id="b1-Header3"
    >
      <div data-container="" className="header-top ThemeGrid_Container">
        <div data-container="" className="header-content display-flex ">
          <div
            data-block="Common.ApplicationTitleJumpV"
            className="ApplicationTitleJumpV OSBlockWidget"
            id="b1-$b2"
          >
            <div className="application_wrapper">
              {!(isPortfolioRoute && !isPortfolioDirectoryRoute) && (
                <div
                  className="fa_bars_head"
                  role="hamburger"
                  onClick={handleMenuClick}
                >
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              )}
              {isValuationEdit && (
                <img className="white_logo" style={{marginRight: "20px"}} src={WhiteLogo} alt="White Logo"/>
              )}
              <div
                data-container=""
                className="logo_wrapper display-flex align-items-center full-height"
                role="button"
                tabIndex="0"
                id="b1-b2-ApplicationTitleWrapper"
                // onClick={handleLogoClick}
              >
                {/* <img
                  data-image=""
                  className="app-logo"
                  // src="https://personal-na0ivtep.outsystemscloud.com/JumpV/img/JumpV_Th.JUMPVTransparent.gif?THg9ccMF3dquF2ddqQOuhQ"
                  src={logo}
                  alt=""
                  id="b1-b2-AppLogo"
                  style={{ width: "431px" }}
                /> */}
                {/* <div className="logo_txt">ValueInsight Pro™</div> */}
                {isPortfolioRoute ? (
                  isPortfolioDirectoryRoute ? (
                    <Link to="/JumpFive/home" className="logo_txt">
                      <img className="white_logo" src={WhiteLogo}/>
                    </Link>
                  ) : (
                    <Link
                      className="logo_txt back_to_directory"
                      // to={`/${APP_PREFIX_PATH}/Portfolio/PortfolioDirectory`}
                      to="/JumpFive/home"
                    >
                      <BackIcon />
                      {/* Back to Directory */}
                      <img className="white_logo" src={WhiteLogo}/>
                    </Link>
                  )
                ) : (
                  <Link to="/JumpFive/home" className="logo_txt">
                    {isValuationEdit ? "" : <img className="white_logo" src={WhiteLogo}/>}
                  </Link>
                )}

                <div>{portfolioName}</div>
                {!isAIAnalyticsPage && <div style={{ width: "100%" }}>{valuationName}</div>}
              </div>
              <div data-container="" className="margin-left-s">
                {/* Feedback button for AI Analytics, Market Share, valuation steps 1-5, valuation directory, and portfolio pages */}
                {(isReportResultsPage || isMarketSharePage || ((state.currentStep >= 1 && state.currentStep <= 5) && isValuationEdit) || isValuationDirectory || isPortfolioDirectory || isPortfolioBuilder || isPortfolioEdit) && (
                  <Button
                    type="default"
                    className="feedback-btn-navbar"
                    icon={<MessageOutlined />}
                    onClick={handleFeedbackClick}
                    style={{ 
                      marginRight: 16,
                      backgroundColor: '#1e468c',
                      borderColor: '#1d5e5c',
                      color: 'black'
                    }}
                  >
                    Feedback
                  </Button>
                )}
                
                <div className="userinfo navbar-userinfo-container">
                  {(isPortfolioBuilderSearch ||
                    isPortfolioEditDebug ||
                    (state.currentStep == 1 && isValuationEdit2)) && (
                    <Tooltip
                      title="AI Advisor"
                      placement="bottom"
                      color="#1d5e5c"
                      overlayInnerStyle={{
                        backgroundColor: "#1d5e5c", // Change background color
                        color: "white", // Change text color
                        fontSize: "14px", // Optional: adjust font size
                      }}
                    >
                      <img
                        src={AiAdvisorLogo}
                        alt="AI Advisor Logo"
                        className="ai-advisor-logo"
                        style={{
                          marginRight: "8px",
                          opacity: isAiAdvisorDisabled ? 0.5 : 1,
                          cursor: isAiAdvisorDisabled
                            ? "not-allowed"
                            : "pointer",
                        }}
                        onClick={() => {
                          if (!isAiAdvisorDisabled) {
                            handleImageClick(); // Only call when not disabled
                          }
                        }}
                        aria-disabled={isAiAdvisorDisabled}
                      />
                    </Tooltip>
                  )}
                  
                  <CustomModal
                    isVisible={isModalVisible}
                    onClose={handleCloseModal}
                    onTabDataFetch={handleTabDataFetch}
                    response={response}
                    loading={loading}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    tabResults={tabResults}
                    setTabResults={setTabResults}
                    currentStep={state.currentStep} // Pass currentStep
                    isValuationEdit={isValuationEdit2}
                    formattedData={formattedData}
                  />

                  <Button
                    type="default"
                    onClick={handleBetaVersionClick}
                    title="Release Notes"
                    className="navbar-release-notes-btn"
                  >
                    Release Notes
                  </Button>

                  <img src={userimg} alt="u_img" className="uimg" />
                  {username}
                </div>
                <div className="OSFillParent" onClick={handleLogout}>
                  <span className="margin-right-s bold">Exit</span>

                  <LogoutOutlined />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    
    {/* Feedback Modal for Market Share, valuation steps, valuation directory, and portfolio pages */}
    {(isMarketSharePage || ((state.currentStep >= 1 && state.currentStep <= 5) || isValuationDirectory || isPortfolioDirectory || isPortfolioBuilder || isPortfolioEdit)) && (!isAIAnalyticsPage || isMarketSharePage) && !isReportResultsPage && (
      <ReportFeedbackModal
        reportData={(() => {
          // Get current page name from URL (similar to NextPrev_V2.jsx)
          const pathname = window.location.pathname;
          const hash = window.location.hash;
          const searchParams = new URLSearchParams(window.location.search);
          
          // Detect page type from URL
          let pageName = null;
          let dealerName = null;
          let dealerInfoId = null;
          
          // Check for specific page types
          if (isMarketSharePage) {
            pageName = "Market Share";
            dealerName = "Market Share";
          } else if (isValuationDirectory) {
            pageName = "Valuation Directory";
            dealerName = "Valuation Directory";
          } else if (isPortfolioDirectory) {
            pageName = "Portfolio Directory";
            dealerName = "Portfolio Directory";
          } else if (isPortfolioBuilder) {
            pageName = "Portfolio Builder";
            dealerName = "Portfolio Builder";
            
            // Check if this is a portfolio search page and extract search parameters
            if (pathname.includes('PortfolioList') && searchParams.get('search_by')) {
              const searchBy = searchParams.get('search_by');
              
              if (searchBy === 'radius') {
                // Radius Search: zipcode/dealership, radius, brand
                const zipcode = searchParams.get('zipcode') || '';
                const radius = searchParams.get('radius') || '';
                const brandParam = searchParams.get('brand') || '';
                
                let radiusFilters = [];
                if (zipcode) radiusFilters.push(`Zipcode/Dealership: ${zipcode}`);
                if (radius) radiusFilters.push(`Radius: ${radius} miles`);
                if (brandParam) {
                  const brandArray = brandParam.split(',').filter(b => b);
                  if (brandArray.length > 0) {
                    radiusFilters.push(`Brand: ${brandArray.join(', ')}`);
                  }
                }
                
                dealerName = radiusFilters.length ? `Radius Search - ${radiusFilters.join(' | ')}` : 'Radius Search';
              } else if (searchBy === 'filter') {
                // Filtered Search: group, brand, state
                const groupParam = searchParams.get('group') || '';
                const brandParam = searchParams.get('brand') || '';
                const stateParam = searchParams.get('state') || '';
                
                let filters = [];
                
                // Handle group (could be JSON encoded array)
                if (groupParam) {
                  try {
                    const groupArray = JSON.parse(decodeURIComponent(groupParam));
                    if (Array.isArray(groupArray) && groupArray.length > 0) {
                      filters.push(`Group: ${groupArray.join(', ')}`);
                    }
                  } catch (e) {
                    const groupArray = groupParam.split(',').filter(g => g);
                    if (groupArray.length > 0) {
                      filters.push(`Group: ${groupArray.join(', ')}`);
                    }
                  }
                }
                
                // Handle brand (comma-separated string)
                if (brandParam) {
                  const brandArray = brandParam.split(',').filter(b => b);
                  if (brandArray.length > 0) {
                    filters.push(`Brand: ${brandArray.join(', ')}`);
                  }
                }
                
                // Handle state (comma-separated string)
                if (stateParam) {
                  const stateArray = stateParam.split(',').filter(s => s);
                  if (stateArray.length > 0) {
                    filters.push(`State: ${stateArray.join(', ')}`);
                  }
                }
                
                dealerName = filters.length ? `Filtered Search - ${filters.join(' | ')}` : 'Filtered Search';
              }
            }
          } else if (isPortfolioEdit) {
            pageName = "Portfolio";
            // Extract portfolio name - it might be a JSX element or string
            let portfolioNameValue = '';
            if (state.portfolioName) {
              if (typeof state.portfolioName === 'string') {
                portfolioNameValue = state.portfolioName;
              } else if (state.portfolioName.props?.children?.props?.children) {
                portfolioNameValue = state.portfolioName.props.children.props.children;
              }
            }
            dealerName = portfolioNameValue ? `Saved Portfolio - Name: ${portfolioNameValue}` : "Portfolio";
          } else {
            // Map of valuation steps to their display names
            const valuationSteps = {
              'radius': 'Radius',
              'financial': 'Financial',
              'performance': 'Performance',
              'summary': 'Summary',
              'real-estate': 'Real Estate',
              'RealEstate': 'Real Estate',
            };

            // Check if current path matches any valuation step
            const matchedStep = Object.keys(valuationSteps).find(step =>
              hash.includes(step) || pathname.includes(step) || (step === 'RealEstate' && state.currentStep === 4)
            );

            if (matchedStep) {
              pageName = valuationSteps[matchedStep];
              dealerName = state.valuationConfig?.dealer_name || state.valuation?.dealer_name || "Valuation";
              dealerInfoId = state.SET_Dealer_Info_Id || "";
            } else if (state.currentStep >= 1 && state.currentStep <= 5) {
              // Fallback to current step detection
              const stepNames = {
                1: "Radius",
                2: "Financials",
                3: "Performance",
                4: "Real Estate",
                5: "Summary"
              };
              pageName = stepNames[state.currentStep] || "Valuation";
              dealerName = state.valuationConfig?.dealer_name || state.valuation?.dealer_name || "Valuation";
              dealerInfoId = state.SET_Dealer_Info_Id || "";
            } else {
              pageName = "Valuation";
              dealerName = "Valuation";
            }
          }

          return {
            dealer_name: dealerName,
            report_type: pageName,
            dealer_info_id: dealerInfoId,
            dealer_city: state.valuationConfig?.dealer_city || state.valuation?.dealer_city || "",
            dealer_state: state.valuationConfig?.dealer_state_code || state.valuation?.dealer_state_code || ""
          };
        })()}
        existingFeedback={state.previousFeedbacks}
        loadingFeedback={state.loadingFeedbacks}
        onFeedbackRefresh={async () => {
          // Refresh the feedback list after saving new feedback
          try {
            dispatch({ type: "SET_LOADING_FEEDBACKS", value: true });
            const response = await axiosInstance.get("/report-feedback");
            if (response.data && response.data.success) {
              dispatch({ 
                type: "SET_PREVIOUS_FEEDBACKS", 
                value: response.data.data || [] 
              });
            }
          } catch (error) {
            console.error("Error refreshing feedbacks:", error);
          } finally {
            dispatch({ type: "SET_LOADING_FEEDBACKS", value: false });
          }
        }}
      />
    )}
    
    {/* Release Notes Modal */}
    <ReleaseNotesModal
      isOpen={isReleaseNotesModalOpen}
      onClose={handleReleaseNotesClose}
      onNext={handleReleaseNotesClose}
      loading={false}
      releaseNotesData={releaseNotesContent}
    />
  </>
  );
}

export default Nav;
